import { useInvalidateAllShopEmailTemplates } from "./use-get-all-shop-email-templates";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

/**
 * Superadmin/CSM onboarding action: generate + link the 8 default return email
 * templates for a shop. Idempotent on the backend.
 */
export default function useGenerateDefaultReturnTemplates(shopId: string) {
	return useApiMutation(
		"post",
		"/super-admin/shops/{shopId}/generate-default-return-templates",
		{
			invalidate: [
				useInvalidateShop(shopId),
				useInvalidateAllShopEmailTemplates(shopId),
			],
			mapVariables: (_variables: void) => ({
				params: { path: { shopId } },
			}),
		},
	);
}
